import React, { useState } from "react";

import { StarFilled } from "@ant-design/icons";
import { Button, Radio } from "antd";
import Modal from "antd/es/modal/Modal";

import "./RetestMethodModal.css";

const RETEST_OPTIONS = [
  {
    key: "existing_sample",
    title: "Retest using existing sample",
    description: "Use the sample already available in the lab.",
    recommended: false,
  },
  {
    key: "new_sample",
    title: "Retest using a new sample",
    description: "Submit a fresh sample for more accurate results.",
    recommended: true,
  },
];

export default function RetestMethodModal({ onCancel, onContinue }) {
  const [selectedMethod, setSelectedMethod] = useState(null);

  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      wrapClassName="RetestMethodModal"
      className="RetestMethodModal"
      width="587px"
    >
      <div className="RetestMethodModal__Body">
        <div className="RetestMethodModal__Content">
          <p className="RetestMethodModal__Question">
            How would you like to proceed with the retest?
          </p>

          <Radio.Group
            className="RetestMethodModal__Options"
            value={selectedMethod}
            onChange={(e) => setSelectedMethod(e.target.value)}
          >
            {RETEST_OPTIONS.map((option) => {
              const isSelected = selectedMethod === option.key;
              return (
                <div
                  key={option.key}
                  className={[
                    "RetestMethodModal__Option",
                    isSelected ? "RetestMethodModal__Option--active" : "",
                  ].filter(Boolean).join(" ")}
                  onClick={() => setSelectedMethod(option.key)}
                >
                  <Radio value={option.key} />
                  <div className="RetestMethodModal__OptionBody">
                    <div className="RetestMethodModal__OptionTitleGroup">
                      <span className="RetestMethodModal__OptionTitle">
                        {option.title}
                      </span>
                      {option.recommended && (
                        <span className="RetestMethodModal__RecommendedBadge">
                          <StarFilled className="RetestMethodModal__RecommendedStar" />
                          <span className="RetestMethodModal__RecommendedText">Recommended</span>
                        </span>
                      )}
                    </div>
                    <span className="RetestMethodModal__OptionDescText">
                      {option.description}
                    </span>
                  </div>
                </div>
              );
            })}
          </Radio.Group>
        </div>
      </div>

      <div className="RetestMethodModal__Footer">
        <Button type="default" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          disabled={!selectedMethod}
          onClick={() => onContinue(selectedMethod)}
        >
          Continue
        </Button>
      </div>
    </Modal>
  );
}
